import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (params) {
  const { data, exec } = useRequest({
    url: '',
    name: 'GET_SPOT_ORG',
    manual: true,
  });

  useEffect(() => {
    if (params) {
      let url = `/api/craft/spotcheck/config`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) url += '?';
        else url += '&';
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return data || [];
});
